import a from"./global.js";var l=a,o=l;export{o as default};
